<div
  fxLayout="row"
  fxLayoutAlign="start center"
  fxLayoutGap="8px"
  class="u-border-grey100 u-borderRadius--4px text-caption u-paddingLeft-8 u-paddingRight-8"
  [ngStyle]="{ paddingTop: '4px', paddingBottom: '4px' }"
  [ngSwitch]="programMembership.status"
>
  <ng-container *ngSwitchCase="'active'">
    <ng-container *ngIf="!programMembership.matches?.length">
      <mat-icon class="color-grey-300 md-16">hourglass_top</mat-icon>
      <p class="text-caption color-grey-300">Waiting for pairing</p>
    </ng-container>
    <ng-container *ngIf="programMembership.matches?.length">
      <mat-icon class="color-teal-700 md-16">sync</mat-icon>
      <p class="text-caption color-teal-700">In progress</p>
    </ng-container>
  </ng-container>
  <ng-container *ngSwitchCase="'declined'">
    <mat-icon class="color-grey-300 md-16">not_interested</mat-icon>
    <p class="text-caption color-grey-300">Declined</p>
  </ng-container>
  <ng-container *ngSwitchCase="'invited'">
    <ng-container *ngIf="!matchmakingPhase?.match_generation_completed">
      <mat-icon class="color-orange md-16">info_outline</mat-icon>
      <p class="text-caption color-orange">Requires action</p>
    </ng-container>
    <ng-container *ngIf="matchmakingPhase?.match_generation_completed">
      <mat-icon class="color-teal-700 md-16">check_circle</mat-icon>
      <p class="text-caption color-teal-700">Program started</p>
    </ng-container>
  </ng-container>
</div>
